import { createRoute,redirect } from '@tanstack/react-router'

import { rootRoute } from './root'

export const footerPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'footer/$page',
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/help/$page', params })
  },
})
